(() => {
  'use strict';
  const root = document.querySelector('[data-cp-product]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  // Localize only this product's existing review UI, preserving text, ratings and disclosures.
  const reviewWidget = document.querySelector('#cp-reviews');
  if (reviewWidget && root.dataset.locale.startsWith('sv')) {
    const reviewLabels = new Map(Object.entries({
      'Write a review':'Skriv en recension','Cancel review':'Avbryt recension',
      'Most Recent':'Senaste','Highest Rating':'Högsta betyg','Lowest Rating':'Lägsta betyg',
      'Only Pictures':'Endast bilder','Pictures First':'Bilder först','Videos First':'Filmer först','Most Helpful':'Mest hjälpsamma',
      'Verified':'Verifierad köpare','Verified Buyer':'Verifierad köpare',
      'Review collected via store invitation':'Recension efter inbjudan från butiken',
      'Review earned a reward for future purchase':'Recensenten fick en belöning för ett framtida köp'
    }));
    const translateReviews = () => {
      reviewWidget.querySelectorAll('.jdgm-write-rev-link,option,.jdgm-rev__transparency-badge,.jdgm-rev__buyer-badge').forEach(el => {
        const translated = reviewLabels.get(el.textContent.trim());
        if (translated) el.textContent = translated;
      });
      reviewWidget.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(el => {
        const match = el.textContent.trim().match(/^Based on (\d+) reviews?$/);
        if (match) el.textContent = 'Baserat på ' + match[1] + ' recensioner';
      });
    };
    translateReviews();
    new MutationObserver(translateReviews).observe(reviewWidget,{childList:true,subtree:true});
  }

  const data = JSON.parse(root.querySelector('[data-cp-data]').textContent);
  let labels = JSON.parse(root.querySelector('[data-cp-labels]').textContent);
  if (typeof labels === 'string') labels = JSON.parse(labels);
  const t = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), labels[key] || key);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const route = root.dataset.root.replace(/\/$/, '');
  const money = value => new Intl.NumberFormat(root.dataset.locale || 'sv', {style:'currency',currency:root.dataset.currency,maximumFractionDigits:value % 100 ? 2 : 0}).format(value / 100);
  const q = selector => root.querySelector(selector);
  const qa = selector => [...root.querySelectorAll(selector)];
  let busy = false, added = false;
  let variant = data.variants.find(v => v.id === data.selected) || data.variants[0];
  const error = message => { q('[data-cp-error]').textContent = message; q('[data-cp-error]').hidden = !message; };
  async function request(path, body) {
    const response = await fetch(route + path, {credentials:'same-origin',...(body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {})});
    const value = await response.json();
    if (!response.ok) throw new Error(value.description || value.message || t('error'));
    return value;
  }
  async function addItem(item, replaceKey = '') {
    error(''); busy = true; renderButtons();
    try {
      await request('/cart/add.js', {items:[item]});
      added = true;
      if (replaceKey) {
        const cart = await request('/cart.js');
        const line = cart.items.find(it => it.key === replaceKey);
        if (line) await request('/cart/change.js', {id:replaceKey,quantity:Math.max(0,line.quantity - 1)});
      }
      const drawer = document.querySelector('cart-drawer');
      const section = drawer?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') || 'cart-drawer';
      const refreshed = await request('/cart/update.js', {updates:{},sections:[section]});
      const cart = await request('/cart.js');
      cart.sections = refreshed.sections || {};
      if (data.bundle) {
        picked = Array(data.bundle).fill(null);
        try { sessionStorage.removeItem(storeKey); } catch (_) { /* Storage can be unavailable. */ }
        params.delete('replace'); params.delete('preselect'); params.delete('add');
        history.replaceState(null, '', location.pathname + (params.size ? '?' + params : ''));
        closePicker();
        renderSlots();
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true,detail:{baseEvent:'variant:add',cart}}));
      if (!drawer) location.assign(route + '/cart');
      added = false;
    } catch (err) {
      if (added) {
        // The item exists. Go to the cart instead of offering a retry that would duplicate it.
        location.assign(route + '/cart');
      } else error(err.message || t('error'));
    } finally { busy = false; renderButtons(); }
  }
  const gallery = q('.cp-gallery-track');
  qa('[data-cp-gallery]').forEach(button => button.addEventListener('click', () => {
    gallery.scrollTo({left:gallery.clientWidth * Number(button.dataset.cpGallery),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }));
  gallery?.addEventListener('scroll', () => {
    const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
    qa('[data-cp-gallery]').forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
  }, {passive:true});
  function renderButtons() {
    qa('[data-cp-buy]').forEach(button => {
      button.disabled = busy || !variant.available;
      button.textContent = busy ? t('adding') : !variant.available ? t('soldOut') : data.bundle
        ? (picked.filter(Boolean).length === data.bundle ? t('addSet') + ' · ' + money(variant.price) : t('chooseCount',{count:data.bundle}) + ' · ' + money(variant.price))
        : offer === 'single' ? t('add') : t(offer === 'kit' ? 'addKit' : 'chooseSet');
    });
  }
  let offer = 'single';
  function renderTotal() {
    const input = q('[name="quantity"]');
    const isSingle = offer === 'single';
    input.disabled = !isSingle;
    qa('[data-cp-quantity]').forEach(button => { button.disabled = !isSingle; });
    const quantity = Math.max(1, Number(input.value) || 1);
    const total = q('[data-cp-total]');
    if (total) total.textContent = money((isSingle ? variant.price * quantity : data[offer].price) + 3900);
  }
  function renderVariant() {
    q('[data-cp-price]').textContent = money(variant.price);
    q('[data-cp-unit]').textContent = variant.title.toLowerCase() + ' · ' + money(Math.round(variant.price / parseFloat(variant.title))) + '/ml';
    qa('.cp-size').forEach(el => el.classList.toggle('selected', el.querySelector('input').value === String(variant.id)));
    const volume = variant.title.toLowerCase().replaceAll(' ', '');
    const keys = volume === '50ml' ? ['three','five'] : volume === '15ml' ? ['minis','kit'] : [];
    q('[data-cp-offers]').innerHTML = keys.length ? `<label class="cp-offer"><input type="radio" name="cp-offer" value="single" checked><span><b>${esc(t('oneBottle'))}</b><small>${esc(variant.title)}</small></span><b>${esc(money(variant.price))}</b></label>` + keys.filter(key => data[key]?.available).map(key => `<label class="cp-offer"><input type="radio" name="cp-offer" value="${key}"><span><b>${esc(t(key))}</b><small>${esc(t(key+'Detail'))}</small></span><b>${esc(money(data[key].price))}</b></label>`).join('') : '';
    offer = 'single';
    renderTotal();
    renderButtons();
    if (variant.featured_media?.id || variant.featured_image?.id) {
      const slide = variant.featured_media?.id ? q(`[data-cp-media="${variant.featured_media.id}"]`) : q(`[data-cp-image="${variant.featured_image.id}"]`);
      if (slide) gallery.scrollTo({left:slide.offsetLeft - gallery.offsetLeft,behavior:'instant'});
    }
  }
  if (!data.bundle) {
    root.addEventListener('change', e => {
      if (e.target.matches('[name="id"]')) {
        variant = data.variants.find(v => String(v.id) === e.target.value);
        renderVariant();
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
      }
      if (e.target.matches('[name="cp-offer"]')) { offer = e.target.value; renderTotal(); renderButtons(); }
      if (e.target.matches('[name="quantity"]')) {
        e.target.value = Math.min(20, Math.max(1, Number(e.target.value) || 1));
        renderTotal();
      }
    });
    qa('[data-cp-quantity]').forEach(button => button.addEventListener('click', () => {
      const input = q('[name="quantity"]'); input.value = Math.min(20,Math.max(1, Number(input.value) + Number(button.dataset.cpQuantity))); input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    q('form').addEventListener('submit', e => {
      e.preventDefault();
      if (busy || !variant.available) return;
      if (offer === 'single') addItem({id:variant.id,quantity:Number(q('[name="quantity"]').value)});
      else if (offer === 'kit') addItem({id:data.kit.id,quantity:1});
      else {
        const url = new URL(data[offer].url, location.origin);
        url.searchParams.set('preselect', root.dataset.handle);
        location.assign(url.href);
      }
    });
    renderVariant();
    return;
  }
  const params = new URLSearchParams(location.search);
  const storeKey = 'c-bx:' + variant.id;
  let picked = Array(data.bundle).fill(null), catalog = [], loaded = false, loading = false, filter = 'all', view = 'catalog', activeSlot = -1, lastFocus;
  const dialog = q('[data-cp-picker]');
  const byHandle = new Map();
  function save() { try { sessionStorage.setItem(storeKey, JSON.stringify(picked)); } catch (_) { /* Optional persistence. */ } }
  function renderSlots() {
    qa('[data-cp-counter]').forEach(el => el.textContent = `${picked.filter(Boolean).length} / ${data.bundle}`);
    qa('[data-cp-slot]').forEach((button,i) => {
      const p = byHandle.get(picked[i]);
      button.innerHTML = `<span class="cp-number">${i+1}</span>${p ? `<img src="${esc(p.i)}" alt="" width="38" height="52">` : ''}<span class="cp-choice-copy"><b>${esc(p ? p.s : t('chooseSlot',{number:i+1}))}</b><small>${esc(p ? (p.r || p.o ? t('inspired')+' '+(p.r||p.o) : p.n.join(' · ')) : t('findOriginal'))}</small></span><span class="${p ? 'cp-choice-action' : ''}">${p ? esc(t('change')) : '+'}</span>`;
    });
    q('[data-cp-status]').textContent = picked.filter(Boolean).length === data.bundle ? t('ready') : t('remaining',{count:data.bundle - picked.filter(Boolean).length});
    renderButtons();
  }
  async function loadCatalog() {
    if (loaded || loading) return;
    loading = true; q('[data-cp-list]').innerHTML = `<p class="cp-picker-empty" role="status">${esc(t('loading'))}</p>`;
    try {
      const responses = await Promise.all(['perfumes','damparfym','herrparfym','unisexparfym'].map(async handle => {
        const response = await fetch(`${route}/collections/${handle}?view=bundle-data`,{credentials:'same-origin'});
        if (!response.ok) throw new Error(t('loadError'));
        return response.json();
      }));
      responses.flat().forEach(p => { if (!byHandle.has(p.h)) byHandle.set(p.h, p); });
      catalog = [...byHandle.values()].sort((a,b) => Number(b.a) - Number(a.a));
      if (!catalog.length) throw new Error(t('loadError'));
      let stored = [];
      try { stored = JSON.parse(sessionStorage.getItem(storeKey) || '[]'); } catch (_) { /* Ignore invalid saved choices. */ }
      const pre = (params.get('preselect') || params.get('add') || '').split(',').filter(Boolean);
      const initial = pre.length ? pre : stored;
      picked = Array.from({length:data.bundle},(_,i) => byHandle.get(initial[i])?.a ? initial[i] : null);
      loaded = true; save(); renderSlots(); renderList();
    } catch (_) {
      q('[data-cp-list]').innerHTML = `<div class="cp-picker-empty"><p>${esc(t('loadError'))}</p><button type="button" class="cp-primary" data-cp-retry>${esc(t('retry'))}</button></div>`;
    } finally { loading = false; }
  }
  function renderList() {
    if (!loaded) return;
    qa('[data-cp-view]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.cpView === view)));
    q('[data-cp-search-tools]').hidden = view !== 'catalog';
    const replacing = activeSlot >= 0 && picked[activeSlot];
    q('[data-cp-replace]').hidden = !replacing || view !== 'catalog';
    q('[data-cp-replace]').textContent = replacing ? t('replacing',{number:activeSlot+1,name:byHandle.get(picked[activeSlot])?.s || ''}) : '';
    if (view === 'selected') {
      q('[data-cp-list]').innerHTML = picked.map((handle,i) => {
        const p = byHandle.get(handle);
        return p ? `<article class="cp-scent"><img src="${esc(p.i)}" alt="" width="59" height="80"><div><small>${esc(t('slot',{number:i+1}))}</small><h3>${esc(p.s)}</h3><p>${esc(p.r || p.o ? t('inspired')+' '+(p.r||p.o) : '')}</p><small>50 ml</small></div><div class="cp-selected-actions"><button type="button" data-cp-edit="${i}">${esc(t('change'))}</button><button type="button" data-cp-remove="${i}">${esc(t('remove'))}</button></div></article>` : `<button type="button" class="cp-choice" data-cp-edit="${i}"><span class="cp-number">${i+1}</span>${esc(t('chooseSlot',{number:i+1}))}<span>+</span></button>`;
      }).join('');
      q('[data-cp-done]').textContent = t('backToSet');
      return;
    }
    const search = q('[data-cp-search]').value.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase().trim();
    const matches = catalog.filter(p => (filter === 'all' || p.g.includes(filter)) && `${p.s} ${p.r} ${p.o} ${p.n.join(' ')}`.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLowerCase().includes(search));
    q('[data-cp-list]').innerHTML = matches.length ? matches.map(p => {
      const times = picked.filter(h => h === p.h).length;
      const full = picked.filter(Boolean).length === data.bundle && activeSlot < 0;
      return `<article class="cp-scent"><img src="${esc(p.i)}" alt="" width="59" height="80" loading="lazy"><div><h3>${esc(p.s)}</h3>${p.r || p.o ? `<p><small>${esc(t('inspired'))}</small> ${esc(p.r||p.o)}</p>` : ''}<p class="cp-notes">${esc(p.n.join(' · '))}</p>${times ? `<small>${esc(t('selectedTimes',{count:times}))}</small>` : ''}</div><div class="cp-scent-bottom"><details><summary>+ ${esc(t('aboutScent'))}</summary><p>${esc(p.d)}</p><a href="${route}/products/${encodeURIComponent(p.h)}" target="_blank" rel="noopener">${esc(t('productDetails'))} ↗</a></details><button type="button" data-cp-pick="${esc(p.h)}"${!p.a || full ? ' disabled' : ''}>${esc(!p.a ? t('soldOut') : full ? t('setFull') : replacing ? t('selectInstead') : t('select'))}</button></div></article>`;
    }).join('') : `<p class="cp-picker-empty">${esc(t('noResults'))}</p>`;
    q('[data-cp-done]').textContent = picked.filter(Boolean).length === data.bundle ? t('reviewChoices') : t('backToSet');
  }
  function openPicker(slot = -1, selectedView = false) {
    lastFocus = document.activeElement; activeSlot = slot; view = selectedView ? 'selected' : 'catalog';
    if (!dialog.open) dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (loaded) renderList(); else loadCatalog();
  }
  function closePicker() { dialog.close(); document.documentElement.style.overflow = ''; lastFocus?.focus({preventScroll:true}); }
  dialog.addEventListener('cancel', () => { document.documentElement.style.overflow = ''; });
  root.addEventListener('click', e => {
    const b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-cp-slot')) openPicker(Number(b.dataset.cpSlot));
    if (b.hasAttribute('data-cp-close')) closePicker();
    if (b.hasAttribute('data-cp-retry')) loadCatalog();
    if (b.hasAttribute('data-cp-view')) { view = b.dataset.cpView; activeSlot = -1; renderList(); }
    if (b.hasAttribute('data-cp-filter')) {
      filter = b.dataset.cpFilter; qa('[data-cp-filter]').forEach(x => x.setAttribute('aria-pressed',String(x === b))); renderList();
    }
    if (b.hasAttribute('data-cp-pick')) {
      const p = byHandle.get(b.dataset.cpPick); if (!p?.a) return;
      const index = activeSlot >= 0 ? activeSlot : picked.indexOf(null); if (index < 0) return;
      const wasReplacement = Boolean(picked[index]); picked[index] = p.h;
      activeSlot = -1; save(); renderSlots();
      if (wasReplacement || picked.every(Boolean)) view = 'selected';
      renderList();
    }
    if (b.hasAttribute('data-cp-edit')) { activeSlot = Number(b.dataset.cpEdit); view = 'catalog'; renderList(); }
    if (b.hasAttribute('data-cp-remove')) { picked[Number(b.dataset.cpRemove)] = null; save(); renderSlots(); renderList(); }
    if (b.hasAttribute('data-cp-done')) {
      if (view === 'catalog' && picked.every(Boolean)) { view = 'selected'; renderList(); } else closePicker();
    }
    if (b.hasAttribute('data-cp-buy') && !busy) {
      if (!picked.every(Boolean)) { openPicker(picked.indexOf(null)); return; }
      const properties = {_handles:picked.join(',')};
      picked.forEach((h,i) => { properties['Parfym '+(i+1)] = byHandle.get(h).t; });
      addItem({id:variant.id,quantity:1,properties},params.get('replace') || '');
    }
  });
  q('[data-cp-search]').addEventListener('input', renderList);
  const dock = q('[data-cp-dock]');
  new IntersectionObserver(entries => { dock.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(q('[data-cp-fields]'));
  renderSlots();
  if (params.get('preselect') || params.get('replace')) loadCatalog();
})();

